<template>
  <div class="login-body">
    <div class="login-container">
      <div class="login-content">
        <el-dropdown @command="changeLanguage" style="margin-left:80%;">
          <span class="el-dropdown-link">
            {{ this.language }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
            <el-dropdown-item command="en-US">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="log-icon-box">
          <img src="../../assets/img/Fill38@2x.png" />
          <div class="title">{{ $t("m.login.sysName") }}</div>
        </div>
        <div class="log-type-box">
          <div class="flex flex-center header-common">
            <span
              class="header-span"
              :class="{ 'header-span-active': active == 1 }"
              @click="active = 1"
              >{{ $t("m.login.tabPwd") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active == 2 }"
              @click="active = 2"
              >{{ $t("m.login.tabCode") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active == 3 }"
              @click="active = 3"
              >{{ $t("m.login.tabEmailCode") }}</span
            >
          </div>
        </div>
        <el-form
          ref="elForm"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="100px"
          class="login-form"
          label-position="left"
        >
          <div class="log-input-box" v-if="active == 1">
            <el-form
              ref="userNameForm"
              :model="formData"
              :rules="rules"
              size="medium"
              label-width="100px"
              label-position="left"
            >
              <el-input
                type="text"
                v-model="formData.username"
                :placeholder="$t('m.login.placeholder.userName')"
              ></el-input>
              <el-input
                type="password"
                v-model="formData.password"
                :placeholder="$t('m.login.placeholder.password')"
              ></el-input>
            </el-form>
          </div>
          <div class="log-input-box" v-if="active == 2">
            <el-form
              ref="mobileForm"
              :model="formData"
              :rules="rules"
              size="medium"
              label-width="100px"
              label-position="left"
            >
              <el-input
                type="text"
                v-model="formData.mobile"
                :placeholder="$t('m.login.placeholder.phone')"
              ></el-input>
              <div class="code-box">
                <el-input
                  type="password"
                  v-model="formData.code"
                  :placeholder="$t('m.login.placeholder.code')"
                ></el-input>
                <el-button @click="getCode" type="primary">{{
                  $t("m.login.getCode")
                }}</el-button>
              </div>
            </el-form>
          </div>
          <div class="log-input-box" v-if="active == 3">
            <el-form
              ref="emailForm"
              :model="formData"
              :rules="rules"
              size="medium"
              label-width="100px"
              label-position="left"
            >
              <el-input
                type="text"
                v-model="formData.email"
                :placeholder="$t('m.login.placeholder.email')"
              ></el-input>
              <div class="code-box">
                <el-input
                  type="password"
                  v-model="formData.code"
                  :placeholder="$t('m.login.placeholder.code')"
                ></el-input>
                <el-button type="primary" @click="getEmailCode" slot="append">{{
                  $t("m.login.getEmailCode")
                }}</el-button>
              </div>
            </el-form>
          </div>
          <div class="log-rem-box">
            <el-checkbox v-model="rememberMe" v-show="showRem">
              {{ $t("m.login.rememberMe") }}
            </el-checkbox>
            <div class="rem-right">
              <span @click="routerLink('register')" class="register-btn">{{
                $t("m.login.register")
              }}</span>
              <span @click="routerLink('forget')">{{
                $t("m.login.forgetPassword")
              }}</span>
            </div>
          </div>
          <div class="log-btn-box">
            <el-button type="warning" @click="submitForm">{{
              $t("m.login.login")
            }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      active: 1,
      formData: {
        mobile: undefined,
        username: undefined,
        password: undefined,
        email: undefined,
        code: undefined,
      },
      language: "中文",
      rememberMe: false,
      showRem: true,
      rules: {
        mobile: [
          {
            required: true,
            message: this.$t("m.login.placeholder.phone"),
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: this.$t("m.login.phoneError"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("m.login.placeholder.email"),
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("m.login.placeholder.email"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("m.login.placeholder.code"),
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: this.$t("m.login.placeholder.userName"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("m.login.placeholder.password"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (localStorage.aqbCofeLang == "en-US") {
      this.$i18n.locale = "en-US"; //关键语句
      this.language = "English";
    }
    this.getCookie();
    this.$refs["elForm"].$el.scrollIntoView();
  },
  methods: {
    changeLanguage(command) {
      if (command == "zh-CN") {
        this.$i18n.locale = "zh-CN"; //关键语句
        this.language = "中文";
        localStorage.aqbCofeLang = "zh-CN";
      } else {
        this.$i18n.locale = "en-US"; //关键语句
        this.language = "English";
        localStorage.aqbCofeLang = "en-US";
      }
    },
    routerLink(type) {
      if (type == "register") {
        this.$router.push("/register").catch((err) => {
          console.info(err);
        });
      } else {
        /*this.$message({
                    type: 'info',
                    message: '页面待添加'
                });*/
        this.$router.push("/forget").catch((err) => {
          console.info(err);
        });
      }
    },
    submitForm() {
      if (this.active == 2) {
        this.$refs["mobileForm"].validate((valid) => {
          if (!valid) return;
          // TODO 提交表单
          this.login();
        });
      } else if (this.active == 3) {
        this.$refs["emailForm"].validate((valid) => {
          if (!valid) return;
          // TODO 提交表单
          this.login();
        });
      } else {
        this.$refs["userNameForm"].validate((valid) => {
          if (!valid) return;
          // TODO 提交表单
          this.login();
        });
      }
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    getCode() {
      let params = new URLSearchParams();
      params.append("phone", this.formData.mobile);
      const phoneNumberRegex = /^1[3456789]\d{9}$/;
      if (!phoneNumberRegex.test(this.formData.mobile)) {
        return this.$message.error(this.$t("m.alert.error")+':'+this.$t("m.alert.phoneError"));
      }
      this.$http
        .post("/manage/user/sendCode.do", params)
        .then(
          function(resp) {
            console.info(resp);
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.codeSuccess"));
            } else {
              this.$message.error(resp.data.msg);
            }
          }.bind(this)
        )
        .catch(function(err) {
          console.error(err);
        });
    },
    getEmailCode() {
      let params = new URLSearchParams();
      params.append("email", this.formData.email);
      this.$http
        .post("/manage/user/sendEmail.do", params)
        .then(
          function(resp) {
            console.info(resp);
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.codeSuccess"));
            } else {
              this.$message.error(resp.data.msg);
            }
          }.bind(this)
        )
        .catch(function(err) {
          console.error(err);
        });
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.formData.username = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.formData.password = arr2[1];
          }
        }
      }
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    login() {
      let params = new URLSearchParams();
      let url = "";
      if (this.active == 2) {
        url = "/manage/user/login_code.do";
        params.append("phone", this.formData.mobile);
        params.append("code", this.formData.code);
      } else if (this.active == 3) {
        url = "/manage/user/login_email_code.do";
        params.append("email", this.formData.email);
        params.append("code", this.formData.code);
      } else {
        if (this.rememberMe) {
          this.setCookie(this.formData.username, this.formData.password, 7);
        } else {
          this.clearCookie();
        }
        url = "/manage/user/login_pwd.do";
        params.append("name", this.formData.username);
        params.append("password", this.formData.password);
      }
      this.$http
        .post(url, params)
        .then(
          function(resp) {
            console.info(resp);
            if (resp.data.success) {
              localStorage.userid = resp.data.data.user.id;
              localStorage.role = resp.data.data.user.role; //发送成功吧role保存用来在index显示
              localStorage.userName = resp.data.data.user.name;
              localStorage.photo = resp.data.data.user.photo;
              localStorage.temUnit = resp.data.data.temUnit;
              localStorage.weight = resp.data.data.weight;
              localStorage.setItem('token', resp.data.data.token);
              this.$router.push("/on-allUserDeviceList").catch((err) => {
                console.info(err);
              });
            } else {
              this.$message.error(
                resp.data.msg
              );
            }
          }.bind(this)
        )
        .catch(function(err) {
          console.error(err);
        });
    },
  },
};
</script>
